export const setEdges = (edges) => {
    return {
        type: "SET_EDGES",
        edges
    }
}
